<!--vipitem-->
<template>
    <div class="newest-card">
        <CourseItemO1>
            <div slot="price" class="price-container">
                <span class="column-number">
                    12集 |
                </span>
                <span class="vip-icon">vip</span>
                <span class="discout-price">66</span>
                <span class="original-price">199</span>
            </div>
        </CourseItemO1>
    </div>
</template>

<script>
    import CourseItemO1 from '../../items/course-item-01.vue'
    export default {
        data() {
            return {
                isVisible: true,
                actions: {},
                intervalTime: {},
                pageHome: true,
                defaultImg: 'this.src="' + require('../../../assets/img/default-bkg.png') + '"',
                itemData:{
                    "qiyihaoId": 1269358361,
                    "contentId": 227463001,
                    "contentName": "从入门到精通：硬笔楷书",
                    "status": 2,
                    "startTime": "2019-08-01 00:00:00",
                    "deadline": "2019-08-07 00:00:00",
                    "createTime": "2019-07-31 10:07:11",
                    "discount": "6",
                    "ruleId": 194,
                    "originPrice": 23800,
                    "discountPrice": 14280,
                    "contentPic": "http://pic7.iqiyipic.com/image/20190731/3e/f7/a_100159346_m_601_m8.jpg",
                    "lessonTotalNum": 38,
                    "promptDescription": "中国人，写好中国字",
                    "lecturer": "吉建忠·中学书法教师"
                },
            }
        },

        components:{
            CourseItemO1
        },

        props: {
            // itemData: Object,
            storeInfo: Object,
            currentTime: Number
        },

        watch: {
            currentTime() {
              this.calIntervalTime()
          }
        },

        created() {

        },

        mounted() {
            this.calIntervalTime()

            const currentRouter = this.$router.currentRoute

            this.pageHome = !(currentRouter.name === 'discount-list' || currentRouter.name === 'preview-discount-list');
        },

        computed: {
            imgUrl() {
                return imgSelector(this.itemData.contentPic)
            },

            calPrice() {
                return priceTimelimit(this.itemData.originPrice, this.itemData.discountPrice)
            },

            startEndTime() {
                if (this.itemData.startTime && this.itemData.deadline) {
                    const start = new Date(this.itemData.startTime.replace(/-/g, '/'))
                    const end = new Date(this.itemData.deadline.replace(/-/g, '/'))
                    if (start && end) {
                        if (start.getFullYear() === end.getFullYear()) {
                            return `${start.getMonth() + 1}.${dateformat(start.getDate())}-${end.getMonth() + 1}.${dateformat(end.getDate())}`
                        }
                        return `${start.getFullYear()}.${start.getMonth() + 1}.${dateformat(start.getDate())}-${end.getFullYear()}.${end.getMonth() + 1}.${dateformat(end.getDate())}`
                    }
                }
                return null
            }
        },

        methods: {

            calIntervalTime() {
                const now = Date.now()
                const endDate = new Date(this.itemData.deadline.replace(/-/g, '/'))
                if (endDate) {
                    const end = endDate.getTime()
                    if (end > now) {
                        this.formatInterval(end - now)
                    } else {
                        this.$emit('remove', this.itemData)
                    }
                }
            },

            formatInterval(interval) {
                interval = interval / 1000
                const d = parseInt(interval / (24 * 60 * 60))
                const h = parseInt(interval / (60 * 60) % 24)
                const m = parseInt(interval / 60 % 60)
                const s = parseInt(interval % 60)

                if (d >= 1) {
                    this.intervalTime = { d:dateformat(d), h: dateformat(h), m: dateformat(m), s: '' }
                } else {
                    this.intervalTime = { d: '', h: dateformat(h), m: dateformat(m), s: dateformat(s) }
                }
            },

            onClick() {
                const channel = this.$getParameterByName("social_platform") || ''
                const rpage = `knowledge_h5_shop_${this.storeInfo.key}_${window.pageTitle}`
                const rseat = `${this.itemData.contentId}_${this.itemData.startTime}_${this.itemData.deadline}`

                pv.click({
                    rpage,
                    block: 'shop_sale',
                    rseat,
                });

                this.actions = {
                    open: true,
                    regParams: {
                        biz_id: "14",
                        biz_params: {
                            biz_dynamic_params: `id=${this.itemData.contentId}`,
                            biz_extend_params: null,
                            biz_h5_params: null,
                            biz_params: null,
                            biz_statistics: `channel=${channel}&s2=${rpage}&s4=${rseat}`,
                            biz_sub_id: "6",
                        }
                    }
                }
                this.$dispatchAction(this);
            }
        },
    }
</script>

<style>
    .newest-card-container .column-number{
        margin-right: 4px;
        color: rgb(102, 102, 102)
    }
    .newest-card-container .discout-price{
        margin-right: 4px;
        color: rgb(102, 102, 102);
        font-weight: bold;
    }
    .newest-card-container .original-price{
        margin-right: 4px;
        text-decoration: line-through;
        color: rgb(181, 181, 181);
    }
    .newest-card-container .vip-icon{
        color: #fff;
        background-color: #f46345;
        width: 20px;
        height:10px;
        text-align: center;
        line-height: 10px;
        display: inline-block;
        margin-right:2px;
        padding-top:1px;
        padding-bottom:1px;
    }
    .newest-card-container .price-container{
        display:flex;
        align-items:center;
    }
</style>